import { useMutation } from '@apollo/client/react';
import { DataTableAddButton } from '@optools/components/data-table/data-table-add-button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@optools/components/ui/dialog';
import { CREATE_SESSION_OVERRIDE } from '@optools/services/operator-gateway/overrides/session/mutations';
import { GET_SESSION_OVERRIDES } from '@optools/services/operator-gateway/overrides/session/queries';
import { ClientType, MatchParams } from '@optools/services/operator-gateway/overrides/types';
import { useState } from 'react';
import { toast } from 'sonner';

import { SessionOverrideForm, SessionOverrideFormValues } from './session-override-form';

export function CreateSessionOverride() {
  const [open, setOpen] = useState(false);

  const [createSessionOverride, { loading }] = useMutation(CREATE_SESSION_OVERRIDE, {
    awaitRefetchQueries: true,
    onCompleted: ({ createSessionOverride }) => {
      if (!createSessionOverride) {
        toast.error('Create Override Error', {
          description: 'Failed to create override, please try again',
          duration: Infinity,
        });
      } else {
        toast.success('Session Override successfully created');

        setOpen(false);
      }
    },
    refetchQueries: [{ query: GET_SESSION_OVERRIDES }],
  });

  const handleClose = (nextOpen: boolean) => {
    if (loading) return;
    setOpen(nextOpen);
  };

  const handleSubmit = (values: SessionOverrideFormValues) => {
    const matchParams: MatchParams = {};
    const { clientType, features, userId } = values;

    if (clientType !== ClientType.ALL_CLIENTS) matchParams.clientType = clientType;
    if (userId) matchParams.userId = userId;

    createSessionOverride({ variables: { features, matchParams } });
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogTrigger asChild>
        <DataTableAddButton>Create Override</DataTableAddButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Override</DialogTitle>
          <DialogDescription className="sr-only">Create a new override</DialogDescription>
        </DialogHeader>
        <SessionOverrideForm loading={loading} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}
